import React, { Component } from 'react'
import Axios from 'axios';
import { MDBBtn, MDBIcon, MDBCard, MDBCardBody, MDBContainer, MDBBox, MDBAlert   } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalregister from './Modalregister';
import Modalfinance from './Modalfinance';
import Commentbnlistforuser from './Commentbnlistforuser';
import Commentexlistforuser from './Commentexlistforuser';




export default class Report extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            Psaaword:'',
            modal: false,
            iduser:'',
            article:[],
            articlepay:[],

            major_precent:'',
            send_type:'',
        };
       
        this.submit = this.submit.bind(this);
        this.list = this.list.bind(this);
         this.handleChangemajor = this.handleChangemajor.bind(this);
          this.handleChangetype = this.handleChangetype.bind(this);
         this.report = this.report.bind(this);
       // this.toggle = this.toggle.bind(this);
      }


    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

      handleChangemajor(event) {    this.setState({major_precent: event.target.value});  }
        handleChangetype(event) {    this.setState({send_type: event.target.value});  }

    submit = (event) => {
        event.preventDefault();

        var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("id", this.state.id);
        datafrm.append("name", this.state.name);
        datafrm.append("lname", this.state.lname);
        datafrm.append("age", this.state.age);
        datafrm.append("sex", this.state.sex);

        if (this.state.update === false) { //เช็คว่าเป็นหน้าสำหรับอัพเดตหรือไม่
            Axios.post('https://conference.kpru.ac.th/PHP/insert.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) })

        }
        else {
            Axios.post('https://conference.kpru.ac.th/PHP/update.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
        }

    }

    componentDidMount() {
    //    this.setState({ iduser: localStorage.getItem('iduser')})


        // setTimeout(() => {
           
        //      Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuser.php?send_id='+localStorage.getItem('iduser'))
        //     .then(res => {
        //       console.log(res);
        
        //       this.setState({ article: res.data})
        //     }) 
      
        //   }, 0);

        //   setTimeout(() => {
          
        //      Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuserpay.php?send_id='+localStorage.getItem('iduser'))
        //     .then(res => {
        //       console.log(res);
          
        //       this.setState({ articlepay: res.data})
        //     }) 
      
        //   }, 0);

      
    }

    list() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuser.php?send_id='+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuserpay.php?send_id='+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);

      
    }


      report() {
       // this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectreport.php?send_type='+this.state.send_type+'&major_precent='+this.state.major_precent)
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

       

      
    }


    render() {

        const date = new Date();
        const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        const dates = day+"-"+month+"-"+year ;

        console.log(dates)


        return (
            <MDBContainer className="mt-1 " fluid>
                <MDBCard>
                    
                    <MDBCardBody>
                        {/* <h1>{this.state.update === true ? <>อัพเดตข้อมูลสมาชิก</> : <>เพิ่มสมาชิก</>}</h1> */}
                      {/* <div className='text-right'><h5>สวัสดีคุณ{localStorage.getItem('nameuser')}</h5></div>   */}
                        

                      <MDBAlert color="primary" >
                      <MDBBox tag="p"><h4><strong>ตรวจสอบการลงทะเบียนนำเสนอ</strong></h4></MDBBox>
                     </MDBAlert>
                        
                             {/* <div className='mb-2 mt-2'> <Modalregister iduser={this.state.iduser} list={this.list} /></div>   */}

                                <div className="mb-2">
                            <label><strong>สาขาการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangemajor}>
                                        <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                         <option value="สาขาคณิตศาสตร์" >สาขาคณิตศาสตร์</option>
                                         <option value="สาขาวิทยาศาสตร์ทั่วไปฟิสิกส์ เคมี/ชีวิวิทยา" >สาขาวิทยาศาสตร์ทั่วไปฟิสิกส์ เคมี / ชีวิวิทยา</option>
                                         <option value="สาขาภาษาอังกฤษ" >สาขาภาษาอังกฤษ</option>
                                         <option value="สาขาภาษาไทย" >สาขาภาษาไทย</option>
                                         <option value="สาขาภาษาจีน/ภาษาเกาหลี" >สาขาภาษาจีน / ภาษาเกาหลี</option>
                                         <option value="สาขาการศึกษาปฐมวัย" >สาขาการศึกษาปฐมวัย</option>
                                         <option value="สาขาพลศึกษา/สุขศึกษา" >สาขาพลศึกษา / สุขศึกษา</option>
                                         <option value="สาขาคอมพิวเตอร์ศึกษา นวัตกรรมและเทคโนโลยีทางการศึกษา" >สาขาคอมพิวเตอร์ศึกษา นวัตกรรมและเทคโนโลยีทางการศึกษา</option>
                                         <option value="สาขาสังคมศึกษา/เกษตร คหกรรมศาสตร์" >สาขาสังคมศึกษา/เกษตร คหกรรมศาสตร์</option>
                                         <option value="สาขาการประถมศึกษา" >สาขาการประถมศึกษา</option>
                                         <option value="สาขาการศึกษาพิเศษ" >สาขาการศึกษาพิเศษ</option>
                                         <option value="สาขานาฏศิลป์ ดนตรี ศิลปะ อุตสาหกรรมศิลป์" >สาขานาฏศิลป์ ดนตรี ศิลปะ อุตสาหกรรมศิลป์</option>
                                         <option value="สาขาหลักสูตรและการสอน การบริหารการศึกษา / ครูรักษ์ถิ่น" >สาขาหลักสูตรและการสอน การบริหารการศึกษา</option>
                                         <option value="สาขาจิตวิทยาการศึกษา / วิจัยและประเมินผลทางการศึกษา" >สาขาจิตวิทยาการศึกษา / วิจัยและประเมินผลทางการศึกษา / ครูรักษ์ถิ่น</option>

                            </select>
                            </div>

                            <div className="mb-2">
                            <label><strong>ประเภทการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype}>
                                        <option>------กรุณาเลือกประเภทนำเสนอ------</option>
                                         <option value="1" >นำเสนอแบบปากเปล่า</option>
                                         <option value="2" >นำเสนอแบบโปสเตอร์</option>
                            </select>
                            </div>
 <div className="text-center">
      <MDBBtn color="primary" className='text-center' onClick={this.report} >บันทึก</MDBBtn>
 </div>
                           
 <label><strong>ข้อมูลลงทะเบียนจะแสดงเมื่อผ่านการตรวจสอบการชำระเงินแล้ว</strong></label>
                             <MDBTable bordered responsive>
                                    <MDBTableHead color="grey darken-1" textWhite>
                                        <tr>
                                        <th>ลำดับ</th>
                                        <th>ชื่อบทความ</th>
                                        <th>ผู้นำเสนอ</th>
                                        <th>สาขานำเสนอ</th>
                                        <th>ประเภท</th>
                                        <th>หลักฐาน</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.article.map((article,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{article.send_name}</td>
                                    <td>{article.namepresent}</td>
                                    <td>{article.major_precent}</td>
                                    <td>{article.send_type === '1' ?<> ปากเปล่า</> :<> โปสเตอร์</> }</td>
                                    <td>
                                        {article.send_status === '1' ?<>
                                       <p className="deep-orange-text"><MDBIcon icon="dna" /> อยู่ระหว่างตรวจสอบ</p> 
                                        </>:<>
                                        {article.send_status === '2' ?<> <p className="teal-text"><MDBIcon icon="check" /> ชำระแล้ว</p></>:<>
                                         <Modalfinance id_send={article.id_send} send_id={article.send_id} send_name={article.send_name} list={this.list}  />
                                        </>}
                                        </> }
                                       
                                         </td>
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable>

                          
   
               

                
                    </MDBCardBody>
                   <hr/>
                 

                    {/* <img src="https://conference.kpru.ac.th/PHPAPI/rerip.png" className="rounded mx-auto d-block w-50" alt="aligment" /> */}
                </MDBCard>
                </MDBContainer>
        )
    }
}

